import request from '@/utils/request'

export function getAppMarkHot(params) {
  return request({
    url: '/website/oapi/appmark/type/list',
    method: 'POST',
    params: params,
  })
}

export function getOrg(params) {
  return request({
    url: '/website/oapi/system/org/list',
    method: 'POST',
    params: params,
  })
}

export function getBanner(params) {
  return request({
    url: '/website/oapi/index/list',
    method: 'POST',
    params: params,
  })
}


export function getDataset(params) {
  return request({
    url: '/opendata/oapi/dataset/pagelist',
    method: 'POST',
    params: params,
  })
}

export function getIface(params) {
  return request({
    url: '/opendata/oapi/iface/pagelist',
    method: 'POST',
    params: params,
  })
}

export function getNews(params) {
  return request({
    url: '/policy/oapi/policy/pagelist',
    method: 'POST',
    params: params,
  })
}

export function feedback(params) {
  return request({
    url: '/remark/oapi/feedback/save',
    method: 'POST',
    params: params,
  })
}


export function getDataMpa(params) {
  return request({
    url: '/opendata/oapi/dataset/datavisualization',
    method: 'POST',
    params: params,
  })
}

export function uploadBase64toImage(params) {
  return request({
    url: '/upload/oapi/upload/singleupload',
    method: 'POST',
    data: params,
  })
}



export function getDataSetAtlas(params) {
  return request({
    url: '/opendata/oapi/dataset/dataatlas',
    method: 'POST',
    params: params,
  })
}



export function getFeedback(params) {
  return request({
    url: '/remark/oapi/feedback/list',
    method: 'POST',
    params: params,
  })
}



export function getDataSetList(params) {
  return request({
    url: '/opendata/oapi/dataset/pagelist',
    method: 'POST',
    params: params,
  })
}


export function getDataSetDetail(params) {
  return request({
    url: '/opendata/oapi/dataset/detail',
    method: 'POST',
    params: params,
  })
}

export function getDataItemList(params) {
  return request({
    url: '/opendata/oapi/dataitem/list',
    method: 'POST',
    params: params,
  })
}




export function getRemark(params) {
  return request({
    url: '/remark/oapi/comment/remark/list',
    method: 'POST',
    params: params,
  })
}
export function getIndexcount(params) {
  return request({
    url: '/opendata//oapi/dataset/indexcount',
    method: 'POST',
    params: params,
  })
}

export function getDataview(params) {
  return request({
    url: '/opendata/oapi/dataset/dataview',
    method: 'POST',
    params: params,
  })
}




export function getIfaceview(params) {
  return request({
    url: '/opendata/oapi/iface/ifaceview',
    method: 'POST',
    params: params,
  })
}





export function getAppmark(params) {
  return request({
    url: '/appmark/oapi/appmark/info/list',
    method: 'POST',
    params: params,
  })
}


export function getAppDetail(params) {
  return request({
    url: '/appmark/oapi/appmark/info/detail',
    method: 'POST',
    params: params,
  })
}


export function getInterfaceList(params) {
  return request({
    url: '/opendata/oapi/iface/pagelist',
    method: 'POST',
    params: params,
  })
}




export function getIfaceDetail(params) {
  return request({
    url: '/opendata/oapi/iface/detail',
    method: 'POST',
    params: params,
  })
}






export function getNewList(params) {
  return request({
    url: '/policy/oapi/policy/pagelist',
    method: 'POST',
    params: params,
  })
}


export function getnewDetail(params) {
  return request({
    url: '/policy/oapi/policy/get',
    method: 'POST',
    params: params,
  })
}



